import { render, staticRenderFns } from "./Knowhow.vue?vue&type=template&id=0bc1c1b2&scoped=true"
import script from "./Knowhow.vue?vue&type=script&lang=ts"
export * from "./Knowhow.vue?vue&type=script&lang=ts"
import style0 from "./Knowhow.vue?vue&type=style&index=0&id=0bc1c1b2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bc1c1b2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0bc1c1b2')) {
      api.createRecord('0bc1c1b2', component.options)
    } else {
      api.reload('0bc1c1b2', component.options)
    }
    module.hot.accept("./Knowhow.vue?vue&type=template&id=0bc1c1b2&scoped=true", function () {
      api.rerender('0bc1c1b2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/statics/Knowhow.vue"
export default component.exports